import vocabDrill from "./widgets/vocab_drill.js"
import mcqQuiz from "./widgets/mcq_quiz.js"

export const registry = {
  [vocabDrill.type]: vocabDrill,
  [mcqQuiz.type]: mcqQuiz
}

export const SUPPORTED_TYPES = Object.keys(registry)

export function widgetFor(type) {
  return Object.prototype.hasOwnProperty.call(registry, type) ? registry[type] : null
}
